module.exports = __webpack_public_path__ + "static/media/open-quotes.2fa471ef.svg";